import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'David Thompson',
      event: 'Corporate Event',
      rating: 5,
      text: 'We\'ve used Marlowes for several company events and they never disappoint. Reliable, punctual, and the quality of food is consistently excellent. Great value for money too.'
    },
    {
      name: 'Emma Richardson',
      event: '50th Birthday Party',
      rating: 5,
      text: 'The buffet was amazing! So much variety and everything tasted homemade and fresh. The team went above and beyond to make sure everything was perfect. Thank you!'
    },
    {
      name: 'Chadderton FC',
      event: 'Matchday Catering',
      rating: 5,
      text: 'Marlowes provides excellent matchday catering for our team. The food is always hot, fresh, and ready on time. Our players and staff love it. Highly professional service!'
    },
    {
      name: 'Lisa Brown',
      event: 'Christening',
      rating: 5,
      text: 'Beautiful presentation and delicious food. They catered for all dietary requirements including vegan and gluten-free options. Stress-free and fantastic service!'
    },
    {
      name: 'Robert Wilson',
      event: 'Anniversary Party',
      rating: 5,
      text: 'Exceptional catering at a reasonable price. The variety was impressive and the quality was restaurant-standard. Highly recommend to anyone looking for professional catering.'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'var(--text-base)' }}>
            What Our Clients Say
          </h2>
          <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--text-subtle-light)' }}>
            Don't just take our word for it - hear from our satisfied customers.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="transition-all card-hover"
              style={{ borderColor: 'var(--color-accent-line)' }}
            >
              <CardContent className="p-6">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      size={20}
                      fill="var(--accent-ui-accent)"
                      style={{ color: 'var(--accent-ui-accent)' }}
                    />
                  ))}
                </div>
                <p className="mb-4 text-base italic" style={{ color: 'var(--text-subtle-light)' }}>
                  "{testimonial.text}"
                </p>
                <div className="border-t pt-4" style={{ borderColor: 'var(--color-accent-coconut)' }}>
                  <p className="font-bold" style={{ color: 'var(--text-base)' }}>
                    {testimonial.name}
                  </p>
                  <p className="text-sm" style={{ color: 'var(--text-subtle-light)' }}>
                    {testimonial.event}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div
            className="inline-block px-8 py-4 rounded-xl"
            style={{ backgroundColor: 'var(--color-accent-coconut)' }}
          >
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Star size={24} fill="var(--accent-ui-accent)" style={{ color: 'var(--accent-ui-accent)' }} />
              <span className="text-3xl font-bold" style={{ color: 'var(--text-base)' }}>4.9/5</span>
            </div>
            <p style={{ color: 'var(--text-subtle-light)' }}>Average rating from 150+ reviews</p>
          </div>
        </div>

        {/* Review CTA with Incentive */}
        <div className="mt-16 max-w-3xl mx-auto">
          <div
            className="relative overflow-hidden rounded-2xl p-8 md:p-12 shadow-2xl"
            style={{ 
              background: 'linear-gradient(135deg, rgba(97, 82, 90, 0.95) 0%, rgba(97, 82, 90, 0.85) 100%)',
            }}
          >
            <div className="relative z-10 text-center">
              <div className="mb-4">
                <span
                  className="inline-block px-6 py-2 rounded-full text-sm font-bold uppercase tracking-wide"
                  style={{ backgroundColor: 'var(--color-accent-lime)', color: 'var(--text-base)' }}
                >
                  🎁 Win Free Food!
                </span>
              </div>
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Share Your Experience
              </h3>
              <p className="text-xl text-white/90 mb-8">
                Leave us a review on Google for a chance to win free catering for your next event!
              </p>
              <a
                href="https://www.google.com/search?client=safari&hs=DyOU&sca_esv=672cfb55ba862964&hl=en-gb&sxsrf=AE3TifOjAcwc3XvPkZr_L4umMVdH28Qabg:1767041600723&q=marlowes+catering+oldham+reviews&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E5KEcp5FkaiUq3VTEW0Lx_8UiF-EJKKq4SbPNWWdMqnA0YbO33-e3hXy1MHUo3ETkGtmDKA-4Qxy3z2_JEpsL0lA2RIl7FNsWTEXyF5TsEvvSJ3Dbg%3D%3D&sa=X&ved=2ahUKEwixjKj31uORAxWXWkEAHYRgIwEQ9qsLegQIFBAJ&biw=390&bih=663&dpr=3#ebo=3"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-3 bg-white text-lg font-bold px-10 py-5 rounded-xl transition-all hover:scale-105 hover:shadow-2xl"
                style={{ color: 'var(--accent-ui-accent)' }}
              >
                <Star size={24} fill="currentColor" />
                <span>Leave a Google Review</span>
              </a>
              <p className="mt-6 text-white/80 text-sm">
                Every review helps us serve you better and support our local business
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;